import { isString } from 'lodash';
import { useCallback } from 'react';
import { ActionSheetOption } from '@shared/components/ActionSheet';
import { useBoolean } from '@shared/util/hooks';
import { i18n } from '@shared/util/i18n';
import { useNavigator } from '@shared/util/navigation';

interface Props {
  cardId: string;
  channelSlug?: string;
  workflowTemplateId?: string | null;
  recurringEntitiesScheduleId?: string;
}

interface BulkEditMenuState {
  isOpen: boolean;
  openBulkEditMenu: VoidFunction;
  closeBulkEditMenu: VoidFunction;
  bulkEditMenuTitle: string;
  bulkEditMenuOptions: ActionSheetOption[];
}

export function useBulkEditMenuItem({
  cardId,
  channelSlug,
  workflowTemplateId,
  recurringEntitiesScheduleId,
}: Props): BulkEditMenuState {
  const { replace } = useNavigator();
  const [isOpen, openBulkEditMenu, closeBulkEditMenu] = useBoolean();

  const navigateToBulkUpdate = useCallback(
    (allOrUpcoming: 'all' | 'upcoming') => {
      if (
        isString(channelSlug) &&
        isString(workflowTemplateId) &&
        isString(recurringEntitiesScheduleId)
      ) {
        replace('CardBulkUpdate', {
          cardId,
          channelSlug,
          workflowTemplateId,
          recurringEntitiesScheduleId,
          allOrUpcoming,
        });
      }
    },
    [replace, cardId, channelSlug, workflowTemplateId, recurringEntitiesScheduleId],
  );

  const bulkEditMenuOptions: ActionSheetOption[] = [
    {
      title: i18n('card.bulkUpdate.menu.submenu.upcomingCards'),
      onPress: () => navigateToBulkUpdate('upcoming'),
    },
    {
      title: i18n('card.bulkUpdate.menu.submenu.allCards'),
      onPress: () => navigateToBulkUpdate('all'),
    },
  ];

  return {
    isOpen,
    openBulkEditMenu,
    closeBulkEditMenu,
    bulkEditMenuTitle: i18n('card.bulkUpdate.menu.submenu.title'),
    bulkEditMenuOptions,
  };
}
